import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BreadcrumbsInterface } from 'common/types/entities/BreadcrumbsInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createBreadcrumbs(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  const breadcrumbs: BreadcrumbsInterface = {
    id: generateId(),
    type: EntityTypeEnum.Breadcrumbs,
    parentId: parentId,
    fontSize: 20,
    itemColor: 'rgba(124, 124, 124, 1)',
    lastItemColor: 'rgba(20, 45, 99, 1)',
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.Breadcrumbs),
  }

  if (masterBlockId) {
    breadcrumbs.masterBlockId = masterBlockId
  }

  return breadcrumbs
}
